module.exports = __webpack_public_path__ + "img/id-badge-regular.50c6279f.svg";